export default {
    mutations: {
        save(state, payload) {
            Object.assign(state, payload);
        }
    }
}


// WEBPACK FOOTER //
// ./src/vuex-extend/base.js